
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other-user/inventory/godiverse/detail",
      function () {
        return require("private-next-pages/other-user/inventory/godiverse/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other-user/inventory/godiverse/detail"])
      });
    }
  